<script>
import checkPermission from "@/utils/permission";

import { mapGetters } from "vuex";

import { getDicyType } from "@/api/dict";
import { getRefuelRecord as getList } from "@/api/vehicle";
import { getList as getStaffList } from "@/api/staff.js";

import { parseTime } from "@/utils";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { showPhoneAlarm } from "@/global/function.js";

import dayjs from "dayjs";

export default {
  components: { Header, Footer },
  data() {
    const EDate = dayjs().format("YYYY/MM/DD");
    const dayTimeStamp = +dayjs().endOf("day");
    const beforeTimeStamp = +dayjs().startOf("month");
    const SDate = dayjs(beforeTimeStamp).format("YYYY/MM/DD");

    const listQuery = {
      limit: 10,
      page: 1,
      data: {
        refuelTypeCode: undefined,
        refuelTypeName: "全部",
      },
      date: {
        show: false,
        min: new Date(2020, 1, 1),
        max: new Date(2030, 12, 31),
        range: SDate + " - " + EDate,
        start: beforeTimeStamp,
        end: dayTimeStamp,
        default: [new Date(SDate), new Date(EDate)],
      },
    };

    const table = {
      listLoading: false,
      fullWidth: document.documentElement.clientWidth,
      key: 0,
      total: 0,
      data: [],
    };

    return {
      listQuery,
      showStatusPicker: false,
      showRefuelPicker: false,
      refuelTypeList: [],
      refuelStatusList: [],
      statusList: [],
      refuelList: [],
      refuelCheckList: [],
      table,
      staffOptions: [],
      imgKey: [
        "vehicleCapImgUrl",
        "faceCapImgUrl",
        "startRefuelImgUrl",
        "refuelingImgUrl",
        "endRefuelImgUrl",
      ],
      showPreview: false,
      showPreviewList: [],
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
    }),
  },
  created() {
    this.getRefuelType();
    this.getListData();
    this.handleGetStaffList();
  },
  methods: {
    checkPermission,
    clickLeft() {
      this.$router.go(-1);
    },
    getStaff(id) {
      return this.staffOptions.find((staff) => +staff.id === +id) || {};
    },
    handleGetStaffList() {
      const data = {
        page: 1,
        limit: 10000,
      };
      const that = this;
      getStaffList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            const staffOptions = [];
            for (let i = 0; i < items.length; i++) {
              staffOptions.push({
                id: items[i].id,
                label: items[i].name,
                value: items[i].wxwork,
              });
            }
            that.staffOptions = staffOptions;
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    pickerDict(dictlist) {
      return dictlist.map((dict) => ({
        name: dict.label,
        value: dict.code,
      }));
    },
    getValue(list, value) {
      return list.find((dict) => dict.value === value) || {};
    },
    onStatusChoose(status) {
      const { value, name } = status;
      this.listQuery.data.refuelTypeCode = value;
      this.listQuery.data.refuelTypeName = name;
      this.showStatusPicker = false;
    },
    onRefuelChoose(refuel) {
      const { value, name } = refuel;
      this.listQuery.data.checkRefuel = value;
      this.listQuery.data.checkRefuelName = name;
      this.showRefuelPicker = false;
    },
    getStatus: function (value) {
      if (value === undefined) return "";
      return this.statusList.find((item) => +item.value === +value)?.name;
    },
    getRefuel: function (value) {
      if (value === undefined) return "";
      return this.refuelList.find((item) => +item.value === +value)?.name;
    },
    handleTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    formatStamp(timestamp) {
      if (typeof timestamp === "number")
        return parseTime(timestamp, "{y}-{m}-{d}  {h}:{i}:{s}");
      else return timestamp;
    },
    getRefuelType() {
      const that = this;
      getDicyType({ type: "refueltype" })
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            if (Array.isArray(data.data) && data.data.length) {
              that.refuelTypeList = data.data[0].dictDataList;
              const list = [{ name: "全部", value: undefined }];
              data.data[0].dictDataList.forEach((dict) => {
                list.push({
                  name: dict.label,
                  value: dict.code,
                });
              });
              that.refuelList = list;
            }
          }
        })
        .catch(() => false);
    },
    async getListData() {
      console.log("listQuery", this.listQuery);
      const payload = {
        page: {
          current: this.listQuery.page,
          size: this.listQuery.limit,
        },
        where: {
          "desc_rr.refuelTime": "1",
          "eq_rr.recordStatus": 1,
          "lk_rr.vehicleNo": this.listQuery.data.vehicleNo || undefined,
          "eq_rr.refuelTypeCode":
            this.listQuery.data.refuelTypeCode || undefined,
          "ge_rr.refuelTime": dayjs(this.listQuery.date.start)
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          "le_rr.refuelTime": dayjs(this.listQuery.date.end)
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      };
      const response = await getList(payload).catch(() => false);
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            false,
            "toast",
            null,
            2000,
            data.code,
            null,
            data.message
          )
        ) {
          this.table.total = data.page.total;
          this.table.data = data.page.records;
        }
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    onConfirmDateChoose(date) {
      const [start, end] = date;
      this.listQuery.date.show = false;
      this.listQuery.date.range = `${this.formatDate(
        start
      )} - ${this.formatDate(end)}`;
      this.listQuery.date.start = new Date(start).getTime();
      this.listQuery.date.end = new Date(end).getTime();
    },
    openPreview(row) {
      const list = [];
      this.imgKey.forEach((key) => {
        if (row[key]) list.push(row[key]);
      });
      this.showPreview = true;
      this.showPreviewList = list;

      console.log("list", list);
    },
  },
};
</script>

<template>
  <div style="background: white">
    <Header
      :show="true"
      title="加油记录"
      left="prepage"
      :click-left="clickLeft"
    />
    <div style="padding-bottom: 8vh">
      <!-- 顶部搜索相关 Cell -->
      <div>
        <van-field
          v-model.trim="listQuery.data.vehicleNo"
          placeholder="请输入"
        >
          <template #label>
            <span style="font-size: 2vh; color: black">车牌号</span>
          </template>
        </van-field>
        <van-cell
          :value="listQuery.data.refuelTypeName"
          is-link
          @click="showStatusPicker = true"
        >
          <template #title>
            <span style="font-size: 2vh">加油类型</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="showStatusPicker"
          :actions="refuelList"
          cancel-text="取消"
          description="请选择查询的加油类型"
          @select="onStatusChoose"
        />
        <van-cell
          :value="listQuery.date.range"
          is-link
          @click="listQuery.date.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">时间区间</span>
          </template>
        </van-cell>
        <van-calendar
          v-model="listQuery.date.show"
          type="range"
          :min-date="listQuery.date.min"
          :max-date="listQuery.date.max"
          :default-date="listQuery.date.default"
          color="#ee0a24"
          :style="{ 'padding-bottom': '30px' }"
          @confirm="onConfirmDateChoose"
        />
        <div style="margin: 8px">
          <van-button
            v-if="checkPermission([428])"
            round
            block
            type="info"
            @click="getListData"
          >
            查询
          </van-button>
        </div>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              :show-message="false"
              style="padding: 0 20px"
              class="tableExpressInfo"
            >
              <el-form-item label="加油类型">
                <span>{{
                  getValue(pickerDict(refuelTypeList), row.refuelTypeCode)
                    .name || ""
                }}</span>
              </el-form-item>
              <el-form-item label="实际加油量">
                <span>{{ row.refuelCap }}</span>
              </el-form-item>
              <el-form-item label="审核人">
                <span>{{ getStaff(row.checkBy).label || row.checkBy || 'system' }}</span>
              </el-form-item>
              <el-form-item label="申请人">
                <span>{{ row.refuellerName }}</span>
              </el-form-item>
              <el-form-item label="加油时间">
                <span>{{ formatStamp(row.refuelTime) }}</span>
              </el-form-item>
              <el-form-item label="上次里程">
                <span>{{ row.lastMile }} KM</span>
              </el-form-item>
              <el-form-item label="本次里程">
                <span>{{ row.thisMile }} KM</span>
              </el-form-item>
              <el-form-item label="上次油耗">
                <span>{{ row.lastOc }} L/KM</span>
              </el-form-item>
              <van-row>
                <van-col
                  v-for="key in imgKey"
                  :key="key"
                >
                  <van-image
                    v-if="!!row[key]"
                    width="20vw"
                    height="20vw"
                    style="margin-right: 16px"
                    fit="cover"
                    :src="row[key]"
                    @click="openPreview(row)"
                  />
                </van-col>
              </van-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="50"
        />
        <el-table-column
          label="车辆名称"
          prop="vehicleName"
          align="center"
          min-width="110"
          show-overflow-tooltip
        />
        <el-table-column
          label="车牌号"
          prop="vehicleNo"
          align="center"
          min-width="90"
          show-overflow-tooltip
        />

        <el-table-column
          label="加油量"
          prop="refuelCap"
          align="center"
          min-width="80"
        />
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="getListData"
      />
      <van-image-preview
        v-model="showPreview"
        :images="showPreviewList"
      >
        <template #index>
          加油抓拍照片
        </template>
      </van-image-preview>
    </div>
    <Footer value="service" />
  </div>
</template>

<style scoped>
.tableExpressInfo .el-form-item {
  margin-bottom: 0 !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>